import { PageRoots, UrlParams } from '@provision/portal-routes';
import { Route } from 'react-router-dom';
import { MetaTags } from 'src/components/MetaTags/meta-tags';
import { UserGroupRules } from 'src/graphql';
import { InboxLanding, InboxPreview } from 'src/pages/Inbox';
import { ProtectedPage } from 'src/routes/components/protected-page';
import { getRoutePath } from 'src/routes/utils';
import { optionalRouteParam, useRouteParams } from 'src/utils/routing';

const InboxRoute = () => {
  const { recordId } = useRouteParams(UrlParams.recordId);
  return recordId ? <InboxPreview /> : <InboxLanding />;
};

export const InboxRoutes = ({ relative }: { relative?: boolean }) => (
  <Route
    element={
      <ProtectedPage
        redirectTo={PageRoots.conversation}
        allowedRules={[UserGroupRules.AccessToInbox]}
      />
    }
  >
    <Route
      path={`${getRoutePath(PageRoots.inbox, relative)}/${optionalRouteParam(UrlParams.recordId)}`}
      element={
        <MetaTags title="Inbox">
          <InboxRoute />
        </MetaTags>
      }
    />
  </Route>
);
